import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomainValue} from '../../../../model/DomainValue';
import {PrimeTemplate} from 'primeng/api';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {Select} from 'primeng/select';

@Component({
  selector: 'app-dropdown-domain',
  standalone: true,
  imports: [
    PrimeTemplate,
    TranslateModule,
    FormsModule,
    Select,
    ReactiveFormsModule
  ],
  templateUrl: './dropdown-domain.component.html',
  styleUrl: './dropdown-domain.component.scss'
})
export class DropdownDomainComponent implements OnInit
{
  @Input() domainCd: string;
  @Input() domainValues: DomainValue[];
  @Input() showDefault: boolean;
  @Input() showIcon: boolean;
  @Input() small: boolean;
  @Input() placeholder: string;
  @Input() showClear: boolean;
  @Input() locked: boolean;
  @Input() loading: boolean;

  @Input() form: UntypedFormGroup;
  @Input() fieldName: string;

  @Input() value: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Output() onValueChanged = new EventEmitter<string>();

  ngOnInit(): void
  {
    console.log('ngOnInit, showDefault: ' + this.showDefault);
    if (this.showDefault && this.domainValues?.length > 0 && !this.value)
      this.value = this.domainValues[0].domainValueCd;
  }

  public valueChanged(item: string): void
  {
    this.valueChange?.emit(item);
    this.onValueChanged?.emit(item);
  }
}
